module.exports = __webpack_public_path__ + "img/correct.14671132.svg";